import './HeaderNotification.scss';

export const HeaderNotification = () => <div className="of-header-notification" id="of-header-notification" />;
